import ChallengesHistoryBlock from './ChallengesHistoryBlock';

export default ChallengesHistoryBlock;
